var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { attrs: { id: "qpe-tooltip" } },
    [
      !_vm.is_disable_vuetify_tooltip
        ? _c(
            "v-tooltip",
            {
              attrs: {
                "content-class": "tooltip",
                "open-delay": "1000",
                top: _vm.tooltip_position === "top",
                right: _vm.tooltip_position === "right",
                bottom: _vm.tooltip_position === "bottom",
                left: _vm.tooltip_position === "left"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "span",
                          _vm._g(_vm._b({}, "span", attrs, false), on),
                          [_vm._t("hovered_item")],
                          2
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            },
            [_vm._v(" "), _vm._t("tooltip_content")],
            2
          )
        : [
            _c(
              "span",
              {
                staticClass: "tooltip--self-made",
                on: {
                  mouseover: function($event) {
                    _vm.is_show_self_made_tooltip = true
                  },
                  mouseleave: function($event) {
                    _vm.is_show_self_made_tooltip = false
                  }
                }
              },
              [_vm._t("hovered_item")],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }